// lib/logger.ts
const isProduction = process.env.NODE_ENV === "production";

export const logger = {
  log: (...args: unknown[]) => {
    if (!isProduction) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (!isProduction) console.warn(...args);
  },
};
